import { Box } from '../Box';
import { Column } from '../Column';
import { Row } from '../Row';
import { Text } from '../Text';
import { ILegalDocumentNode } from './Types';

interface ILegalDocumentProps {
  content: ILegalDocumentNode;
  depth?: number;
  indent?: number;
}

export const LegalDocumentItem = ({ content, depth = 0, indent = 24 }: ILegalDocumentProps) => {
  return (
    <Column marginBottom={20}>
      <Row gap={16} paddingLeft={depth * indent}>
        <Box minWidth={24}>
          <Text>{content.id}.</Text>
        </Box>
        <Box flex={1}>
          <Text textAlign="justify">
            {content.title.length > 0 && <Text textDecoration="underline">{content.title}:</Text>}{' '}
            {content.description}
          </Text>
        </Box>
      </Row>
      {content.children?.map((it) => (
        <LegalDocumentItem key={it.id} content={it} depth={1} indent={indent + 16} />
      ))}
    </Column>
  );
};
